import {
  Assessment as AssessmentIcon,
  AttachMoney as AttachMoneyIcon,
  Business as BusinessIcon,
  Close as CloseIcon,
  Dashboard as DashboardIcon,
  Description as DescriptionIcon,
  Edit as EditIcon,
  ExpandLess,
  ExpandMore,
  Gavel as GavelIcon,
  Home as HomeIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  List as ListIcon,
  Menu as MenuIcon,
  Newspaper as NewspaperIcon,
  Park as ParkIcon,
  Person as PersonIcon,
  RateReview as RateReviewIcon,
} from "@mui/icons-material";
import {
  alpha,
  AppBar,
  Avatar,
  Box,
  Button,
  Collapse,
  Container,
  Divider,
  Drawer,
  IconButton,
  List as MuiList,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/auth";
import alertaService from "../services/alerta";
import AlertasModal from "./AlertasModal";
import UserSettingsModal from "./UserSettingsModal";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Badge } from "@mui/material";
import { Assignment as AssignmentIcon } from "@mui/icons-material";

function Navbar() {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [expandedMobileMenus, setExpandedMobileMenus] = useState({});
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [openMenus, setOpenMenus] = useState({});
  const [anchorEls, setAnchorEls] = useState({});
  const [currentUser, setCurrentUser] = useState(null);
  const [isAnalista, setIsAnalista] = useState(false);
  const [isSecretario, setIsSecretario] = useState(false);
  const [isPessoaJuridica, setIsPessoaJuridica] = useState(false);
  const [alertas, setAlertas] = useState([]);
  const [alertasModalOpen, setAlertasModalOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    const atualizarDadosUsuario = async () => {
      const user = authService.getCurrentUser();
      setCurrentUser(user);

      if (user && user.data) {
        setIsAnalista(!!user.data.isAnalista || false);
        setIsSecretario(!!user.data.isSecretario || false);
        setIsPessoaJuridica(
          user.data.tipoUsuario === 4 || !!user.data.pessoaJuridica || false,
        );
      } else {
        setIsAnalista(false);
        setIsSecretario(false);
        setIsPessoaJuridica(false);
      }

      const carregarAlertas = async () => {
        try {
          const dados = await alertaService.getMinhasAlertas();
          setAlertas(Array.isArray(dados) ? dados : []);
        } catch {
          setAlertas([]);
        }
      };

      if (user && user.token) {
        carregarAlertas();
      } else {
        setAlertas([]);
      }
    };

    atualizarDadosUsuario();
    return () => {};
  }, [navigate]);

  const handleAbrirAlertas = async () => {
    setAlertasModalOpen(true);
    try {
      await alertaService.marcarVistas();
      setAlertas((prev) => prev.map((a) => ({ ...a, visualizadoEm: a.visualizadoEm ?? new Date().toISOString() })));
    } catch {
      // silencioso — não quebrar a UI
    }
  };

  const homeMenu = {
    id: "home",
    title: "Início",
    icon: <HomeIcon fontSize="small" />,
    path: "/",
  };

  const publicacoesMenu = {
    id: "publicacoes",
    title: "Publicações",
    icon: <NewspaperIcon fontSize="small" />,
    path: "/publicacoes",
  };

  // Menus que aparecem apenas para usuários logados
  const authenticatedMenus = [
    isAnalista || isSecretario
      ? {
          id: "licenciamento",
          title: "Licenciamento",
          icon: <DescriptionIcon fontSize="small" />,
          path: isAnalista ? "/dashboard-analista" : "/secretario/dashboard",
        }
      : {
          id: "licenciamento",
          title: "Licenciamento",
          icon: <DescriptionIcon fontSize="small" />,
          subItems: [
            {
              title: "Licenciamento",
              path: "/dashboard",
              icon: <DescriptionIcon fontSize="small" />,
            },
            {
              title: "Autorizações",
              path: "/autorizacoes",
              icon: <AssignmentIcon fontSize="small" />,
            },
          ],
        },
    {
      id: "interessado",
      title: "Interessado",
      icon: <PersonIcon fontSize="small" />,
      subItems: [
        {
          title: "Alterar Dados",
          path: isPessoaJuridica
            ? "/perfil/empresa/editar"
            : "/interessado/alterar-dados",
          icon: <EditIcon fontSize="small" />,
        },
        {
          title: "Auto de Infração",
          path: "/interessado/auto-infracao",
          icon: <GavelIcon fontSize="small" />,
        },
        {
          title: "Empreendimentos",
          path: "/interessado/empreendimentos",
          icon: <BusinessIcon fontSize="small" />,
        },
        {
          title: "Declarações/Requerimentos",
          path: "/interessado/declaracoes",
          icon: <AssignmentIcon fontSize="small" />,
        },
      ],
    },
  ];

  // Menus públicos adicionais (serviços e simulador)
  const additionalPublicMenus = [
    {
      id: "simulador",
      title: "Simulador",
      icon: <AssessmentIcon fontSize="small" />,
      subItems: [
        {
          title: "Checklist",
          icon: <ListIcon fontSize="small" />,
          path: "/simulador/checklist",
        },
        ...(isAnalista
          ? [
              {
                title: "Taxas de Licenciamento",
                icon: <AttachMoneyIcon fontSize="small" />,
                path: "/analista/taxas-licenciamento",
              },
            ]
          : []),
      ],
    },
  ];

  // Menus que aparecem apenas para analistas
  const analistaMenus = [
    {
      id: "dashboard-analista",
      title: "Dashboard Analista",
      icon: <DashboardIcon fontSize="small" />,
      path: "/analista/dashboard",
    },
    {
      id: "analises",
      title: "Análises",
      icon: <AssessmentIcon fontSize="small" />,
      subItems: [
        {
          title: "Relatórios",
          icon: <AssessmentIcon fontSize="small" />,
          path: "/analista/relatorios",
        },
        {
          title: "Parecer Técnico",
          icon: <RateReviewIcon fontSize="small" />,
          path: "/analista/parecer-tecnico",
        },
      ],
    },
    {
      id: "cadastro",
      title: "Cadastro de Dados",
      icon: <AppRegistrationIcon fontSize="small" />,
      path: "/analista/cadastro-dados",
    },
  ];

  // Cadastro/uso de Responsável Técnico desativado
  // const responsavelTecnicoMenus = [
  //   {
  //     id: "licencas-resp-tecnico",
  //     title: "Licenças Associadas",
  //     icon: <SchoolIcon fontSize="small" />,
  //     path: "/responsavel-tecnico/licencas",
  //   },
  // ];

  const secretarioMenus = [
    {
      id: "dashboard-secretario",
      title: "Dashboard Secretário",
      icon: <DashboardIcon fontSize="small" />,
      path: "/secretario/dashboard",
    },
  ];

  const handleMenuClick = (event, menuId) => {
    if (openMenus[menuId]) {
      handleMenuClose(menuId);
      return;
    }
    setAnchorEls((prev) => ({
      ...prev,
      [menuId]: event.currentTarget,
    }));
    setOpenMenus((prev) => ({
      ...prev,
      [menuId]: true,
    }));
  };

  const handleMenuClose = (menuId) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuId]: false,
    }));
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
    setOpenMenus({});
    setMobileDrawerOpen(false);
  };

  const handleToggleMobileSubmenu = (menuId) => {
    setExpandedMobileMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId],
    }));
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = async () => {
    await authService.logout();
    setCurrentUser(null);
    setIsAnalista(false);
    setIsSecretario(false);
    setIsPessoaJuridica(false);
    navigate("/login");
  };

  const navButtonSx = {
    my: { md: 1.5, lg: 2 },
    color: "text.primary",
    mx: { md: 0.5, lg: 1 },
    fontSize: { md: "0.8rem", lg: "0.875rem" },
    px: { md: 1, lg: 1.5 },
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
  };

  const renderDesktopNavItem = (menu) => {
    if (menu.path && !menu.subItems) {
      return (
        <Button
          key={menu.id}
          onClick={() => navigate(menu.path)}
          sx={navButtonSx}
          startIcon={menu.icon}
        >
          {menu.title}
        </Button>
      );
    }

    return (
      <Box key={menu.id} component="span" sx={{ display: "inline-flex" }}>
        <Button
          onClick={(e) => handleMenuClick(e, menu.id)}
          sx={navButtonSx}
          startIcon={menu.icon}
          endIcon={<KeyboardArrowDownIcon />}
          aria-controls={openMenus[menu.id] ? `nav-menu-${menu.id}` : undefined}
          aria-haspopup="true"
          aria-expanded={openMenus[menu.id] ? "true" : undefined}
        >
          {menu.title}
        </Button>
        {menu.subItems && (
          <Menu
            id={`nav-menu-${menu.id}`}
            anchorEl={anchorEls[menu.id]}
            open={Boolean(openMenus[menu.id])}
            onClose={() => handleMenuClose(menu.id)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            slotProps={{
              paper: { elevation: 3, sx: { minWidth: 200 } },
            }}
            MenuListProps={{ autoFocusItem: Boolean(openMenus[menu.id]) }}
          >
            {menu.subItems.map((item) => (
              <MenuItem
                key={item.path}
                onClick={() => handleMenuItemClick(item.path)}
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                {item.icon}
                <Typography>{item.title}</Typography>
              </MenuItem>
            ))}
          </Menu>
        )}
      </Box>
    );
  };

  const notificacoesNaoLidas = alertas.filter((alerta) => !alerta.visualizadoEm)
    .length;
  const notificacoesAriaLabel =
    notificacoesNaoLidas === 0
      ? "Notificações"
      : notificacoesNaoLidas === 1
        ? "Notificações, 1 não lida"
        : `Notificações, ${notificacoesNaoLidas} não lidas`;

  return (
    <AppBar
      component="nav"
      aria-label="Principal"
      position="sticky"
      sx={{
        backgroundColor: "background.paper",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        width: "100%",
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 1.5, sm: 2, md: 3 } }}>
        <Toolbar
          disableGutters
          sx={{
            minHeight: { xs: 56, sm: 64 },
            px: { xs: 0.5, sm: 1 },
          }}
        >
          {/* Logo - Desktop */}
          <ParkIcon
            sx={{
              display: { xs: "none", md: "flex" },
              mr: 1,
              color: theme.palette.primary.main,
            }}
          />
          <Typography
            variant="h6"
            noWrap
            sx={{
              mr: { md: 1.5, lg: 2 },
              display: { xs: "none", md: "flex" },
              fontWeight: 700,
              fontSize: { md: "1rem", lg: "1.25rem" },
              color: theme.palette.primary.main,
              textDecoration: "none",
              cursor: "pointer",
            }}
            onClick={() => navigate("/")}
          >
            LicenCear
          </Typography>

          {/* Menu Mobile */}
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="medium"
              aria-label="Abrir menu"
              onClick={() => setMobileDrawerOpen(true)}
              sx={{ color: theme.palette.primary.main, ml: -0.5 }}
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="bottom"
              open={mobileDrawerOpen}
              onClose={() => setMobileDrawerOpen(false)}
              PaperProps={{
                "aria-label": "Menu principal",
                sx: {
                  borderTopLeftRadius: 16,
                  borderTopRightRadius: 16,
                  maxHeight: "80vh",
                },
              }}
            >
              <Box sx={{ p: { xs: 1.5, sm: 2 }, overflowY: "auto" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: "1rem", sm: "1.25rem" },
                      color: theme.palette.primary.main,
                    }}
                  >
                    Menu
                  </Typography>
                  <IconButton
                    aria-label="Fechar menu"
                    onClick={() => setMobileDrawerOpen(false)}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
                <Divider sx={{ mb: 1 }} />
                <MuiList disablePadding>
                  {!currentUser && (
                    <ListItemButton
                      key={homeMenu.id}
                      onClick={() => handleMenuItemClick(homeMenu.path)}
                    >
                      <ListItemIcon sx={{ minWidth: 40 }}>
                        {homeMenu.icon}
                      </ListItemIcon>
                      <ListItemText primary={homeMenu.title} />
                    </ListItemButton>
                  )}

                  <ListItemButton
                    key={publicacoesMenu.id}
                    onClick={() => handleMenuItemClick(publicacoesMenu.path)}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      {publicacoesMenu.icon}
                    </ListItemIcon>
                    <ListItemText primary={publicacoesMenu.title} />
                  </ListItemButton>

                  {currentUser &&
                    !isAnalista &&
                    !isSecretario &&
                    authenticatedMenus.map((menu) =>
                      menu.subItems ? (
                        <React.Fragment key={menu.id}>
                          <ListItemButton
                            onClick={() => handleToggleMobileSubmenu(menu.id)}
                          >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                              {menu.icon}
                            </ListItemIcon>
                            <ListItemText primary={menu.title} />
                            {expandedMobileMenus[menu.id] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItemButton>
                          <Collapse
                            in={expandedMobileMenus[menu.id] || false}
                            timeout="auto"
                            unmountOnExit
                          >
                            <MuiList disablePadding>
                              {menu.subItems.map((item) => (
                                <ListItemButton
                                  key={item.path}
                                  sx={{ pl: 6 }}
                                  onClick={() => handleMenuItemClick(item.path)}
                                >
                                  <ListItemIcon sx={{ minWidth: 36 }}>
                                    {item.icon}
                                  </ListItemIcon>
                                  <ListItemText primary={item.title} />
                                </ListItemButton>
                              ))}
                            </MuiList>
                          </Collapse>
                        </React.Fragment>
                      ) : (
                        <ListItemButton
                          key={menu.id}
                          onClick={() => handleMenuItemClick(menu.path)}
                        >
                          <ListItemIcon sx={{ minWidth: 40 }}>
                            {menu.icon}
                          </ListItemIcon>
                          <ListItemText primary={menu.title} />
                        </ListItemButton>
                      ),
                    )}

                  {!isSecretario && additionalPublicMenus.map((menu) =>
                    menu.subItems ? (
                      <React.Fragment key={menu.id}>
                        <ListItemButton
                          onClick={() => handleToggleMobileSubmenu(menu.id)}
                        >
                          <ListItemIcon sx={{ minWidth: 40 }}>
                            {menu.icon}
                          </ListItemIcon>
                          <ListItemText primary={menu.title} />
                          {expandedMobileMenus[menu.id] ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          )}
                        </ListItemButton>
                        <Collapse
                          in={expandedMobileMenus[menu.id] || false}
                          timeout="auto"
                          unmountOnExit
                        >
                          <MuiList disablePadding>
                            {menu.subItems.map((item) => (
                              <ListItemButton
                                key={item.path}
                                sx={{ pl: 6 }}
                                onClick={() => handleMenuItemClick(item.path)}
                              >
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                  {item.icon}
                                </ListItemIcon>
                                <ListItemText primary={item.title} />
                              </ListItemButton>
                            ))}
                          </MuiList>
                        </Collapse>
                      </React.Fragment>
                    ) : (
                      <ListItemButton
                        key={menu.id}
                        onClick={() => handleMenuItemClick(menu.path)}
                      >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          {menu.icon}
                        </ListItemIcon>
                        <ListItemText primary={menu.title} />
                      </ListItemButton>
                    ),
                  )}

                  {/* Menus do analista */}
                  {isAnalista &&
                    analistaMenus.map((menu) =>
                      menu.subItems ? (
                        <React.Fragment key={menu.id}>
                          <ListItemButton
                            onClick={() => handleToggleMobileSubmenu(menu.id)}
                          >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                              {menu.icon}
                            </ListItemIcon>
                            <ListItemText primary={menu.title} />
                            {expandedMobileMenus[menu.id] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItemButton>
                          <Collapse
                            in={expandedMobileMenus[menu.id] || false}
                            timeout="auto"
                            unmountOnExit
                          >
                            <MuiList disablePadding>
                              {menu.subItems.map((item) => (
                                <ListItemButton
                                  key={item.path}
                                  sx={{ pl: 6 }}
                                  onClick={() => handleMenuItemClick(item.path)}
                                >
                                  <ListItemIcon sx={{ minWidth: 36 }}>
                                    {item.icon}
                                  </ListItemIcon>
                                  <ListItemText primary={item.title} />
                                </ListItemButton>
                              ))}
                            </MuiList>
                          </Collapse>
                        </React.Fragment>
                      ) : (
                        <ListItemButton
                          key={menu.id}
                          onClick={() => handleMenuItemClick(menu.path)}
                        >
                          <ListItemIcon sx={{ minWidth: 40 }}>
                            {menu.icon}
                          </ListItemIcon>
                          <ListItemText primary={menu.title} />
                        </ListItemButton>
                      ),
                    )}

                  {isSecretario &&
                    secretarioMenus.map((menu) => (
                      <ListItemButton
                        key={menu.id}
                        onClick={() => handleMenuItemClick(menu.path)}
                      >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          {menu.icon}
                        </ListItemIcon>
                        <ListItemText primary={menu.title} />
                      </ListItemButton>
                    ))}
                </MuiList>
              </Box>
            </Drawer>
          </Box>

          {/* Logo - Mobile */}
          <ParkIcon
            sx={{
              display: { xs: "flex", md: "none" },
              mr: 1,
              color: theme.palette.primary.main,
            }}
          />
          <Typography
            variant="h6"
            noWrap
            sx={{
              mr: 1,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontWeight: 700,
              fontSize: { xs: "1rem", sm: "1.2rem" },
              color: theme.palette.primary.main,
              textDecoration: "none",
              cursor: "pointer",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            onClick={() => navigate("/")}
          >
            SIGA
          </Typography>

          {/* Menu Desktop */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              flexWrap: "wrap",
              alignItems: "center",
              gap: { md: 0, lg: 0.5 },
              overflow: "visible",
            }}
          >
            {!currentUser && renderDesktopNavItem(homeMenu)}
            {renderDesktopNavItem(publicacoesMenu)}

            {currentUser &&
              !isAnalista &&
              !isSecretario &&
              authenticatedMenus.map((menu) => renderDesktopNavItem(menu))}

            {!isSecretario &&
              additionalPublicMenus.map((menu) => renderDesktopNavItem(menu))}

            {isAnalista && analistaMenus.map((menu) => renderDesktopNavItem(menu))}

            {isSecretario &&
              secretarioMenus.map((menu) => renderDesktopNavItem(menu))}
          </Box>

          {/* Menu do Usuário */}
          {currentUser ? (
            <Box
              sx={{
                flexGrow: 0,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                ml: { xs: 0.5, md: 1 },
              }}
            >
              {currentUser.token && (
                <Tooltip title={notificacoesAriaLabel}>
                  <IconButton
                    onClick={handleAbrirAlertas}
                    size="small"
                    aria-label={notificacoesAriaLabel}
                    sx={{ mr: { xs: 0.5, sm: 1 }, color: theme.palette.primary.main }}
                  >
                    <Badge
                      variant="dot"
                      color="error"
                      invisible={notificacoesNaoLidas === 0}
                    >
                      <NotificationsIcon />
                    </Badge>
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Abrir configurações">
                <IconButton
                  onClick={handleOpenUserMenu}
                  sx={{ p: 0 }}
                  aria-label="Abrir configurações"
                  aria-haspopup="dialog"
                  aria-expanded={Boolean(anchorElUser)}
                  aria-controls={
                    anchorElUser ? "user-settings-dialog" : undefined
                  }
                >
                  <Avatar
                    sx={{
                      width: { xs: 32, sm: 40 },
                      height: { xs: 32, sm: 40 },
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                      bgcolor: theme.palette.primary.main,
                      color: "white",
                    }}
                  >
                    {currentUser.username?.[0]?.toUpperCase() || "U"}
                  </Avatar>
                </IconButton>
              </Tooltip>
              <UserSettingsModal
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
                onAlterarSenha={() => navigate("/perfil/alterar-senha")}
                onSair={handleLogout}
              />
            </Box>
          ) : (
            <Button
              variant="contained"
              size="small"
              onClick={() => navigate("/login")}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                flexShrink: 0,
                px: { xs: 1.5, sm: 2 },
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
              }}
            >
              Entrar
            </Button>
          )}
        </Toolbar>
      </Container>
      <AlertasModal
        open={alertasModalOpen}
        onClose={() => setAlertasModalOpen(false)}
        alertas={alertas}
      />
    </AppBar>
  );
}

export default Navbar;
